import { render, staticRenderFns } from "./ListImageGroups.vue?vue&type=template&id=d6de89a6&scoped=true"
import script from "./ListImageGroups.vue?vue&type=script&lang=js"
export * from "./ListImageGroups.vue?vue&type=script&lang=js"
import style0 from "./ListImageGroups.vue?vue&type=style&index=0&id=d6de89a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6de89a6",
  null
  
)

export default component.exports